export const RED = '#e74c3c';
export const GREEN = '#66d997';
export const WHEAT = '#e7e7e7';
export const SILVER = '#8d8d8d';
export const SILVER_LABEL_NONE = '#BDBDBD';
export const CHARCOAL = '#333333';
export const YELLOW = '#fea628';
